module.exports = __webpack_public_path__ + "img/2.e34a98ef.png";